import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-email-pj',
  templateUrl: './email-pj.component.html',
  styleUrls: ['./../cadastral-pj/cadastral-pj.component.css','./email-pj.component.css']
})
export class EmailPjComponent implements OnInit {

  @Input() dados:any;
  public txtButtonConsultar:string='Consultar agora';
  public consultando:Boolean=false;
  public naoSolicitou:Boolean=false;
  public naoEncontrouRegistros:Boolean=false;
  public modalRef:BsModalRef;

  constructor(private modalService:BsModalService) { }
  

  ngOnInit() {
    if(this.dados.email===undefined){
      this.naoSolicitou=true;
    }else if(this.dados.email===null){
      this.naoEncontrouRegistros=true;
    }
  }

}
